import { useState } from 'react';
import QRCode from 'react-qr-code';

import QRCodeRealSvg from '../../../assets/icons/QRCodeRealSvg';
import { IconWrapper } from '../../_atoms/IconWrapper';
import BaseModal from '../BaseModal';

const QRCodeShareButton = ({ url }: { url: string }) => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <BaseModal
        onCancel={() => {
          setVisible(false);
        }}
        open={visible}
        hideCancel
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
          }}
        >
          <QRCode value={url} size={280} />
        </div>
      </BaseModal>
      <IconWrapper
        onClick={() => setVisible(true)}
        style={{ alignItems: 'flex-start' }}
        height="32px"
        width="32px"
      >
        <QRCodeRealSvg />
      </IconWrapper>
    </>
  );
};

export default QRCodeShareButton;
